import type { Dictionary } from './en';

export const de: Dictionary = {
  'common.cancel': 'Abbrechen',
  'common.back': 'Zurück',
  'common.retry': 'Erneut versuchen',
  'common.copy': 'Kopieren',
  'common.copied': 'Kopiert',
  'common.share': 'Teilen',
  'common.delete': 'Löschen',
  'common.revoke': 'Widerrufen',
  'common.close': 'Schließen',
  'common.loading': 'Wird geladen',
  'common.optional': 'Optional',
  'common.or': 'oder',
  'common.none': 'Keine',
  'common.required': 'Erforderlich',
  'common.notSet': 'Nicht festgelegt',
  'common.skipToContent': 'Zum Hauptinhalt springen',
  'common.moment': 'Einen Moment…',

  'brand.tagline': 'Teilen Sie ein Video. Ein einziges Mal.',
  'brand.home': 'BOOMSHOT - Startseite',
  'brand.footerLimit':
    'BOOMSHOT gewährleistet eine sichere einmalige Wiedergabe. Keine Technologie kann einen Screenshot oder eine Bildschirmaufnahme verhindern.',

  'nav.main': 'Hauptnavigation',
  'nav.myVideos': 'Meine Videos',
  'nav.privacy': 'Datenschutz',
  'nav.signIn': 'Anmelden',
  'nav.signOut': 'Abmelden',
  'nav.settings': 'Kontoeinstellungen',
  'nav.openMenu': 'Menü öffnen',
  'nav.closeMenu': 'Menü schließen',

  'theme.light': 'Helles Design - zu dunkel wechseln',
  'theme.dark': 'Dunkles Design - zu automatisch wechseln',
  'theme.system': 'Automatisches Design - zu hell wechseln',
  'theme.label': 'Erscheinungsbild',
  'theme.optionSystem': 'Automatisch',
  'theme.optionLight': 'Hell',
  'theme.optionDark': 'Dunkel',

  'language.label': 'Sprache',
  'language.change': 'Sprache wechseln',

  'landing.title': 'Teilen Sie ein Video. Ein einziges Mal.',
  'landing.subtitle':
    'Ihr privater Link wird nach der ersten Wiedergabe unbrauchbar und das Video automatisch gelöscht.',
  'landing.ctaNew': 'Privaten Link erstellen',
  'landing.ctaSend': 'Video senden',
  'landing.haveAccount': 'Ich habe bereits ein Konto',
  'landing.assure.encrypted': 'Verschlüsselt übertragen',
  'landing.assure.deleted': 'Nach dem Ansehen gelöscht',
  'landing.assure.noReplay': 'Keine Wiederholung',
  'landing.how': 'Drei Schritte. Keine zweite Chance.',
  'landing.step1.title': 'Senden',
  'landing.step1.body':
    'Legen Sie ein Video ab. Es wird in Fragmente umgewandelt, die aus privatem Speicher ausgeliefert werden - nie über eine öffentliche URL.',
  'landing.step2.title': 'Einstellen',
  'landing.step2.body':
    'Ablauf, Zugangscode, Wasserzeichen, Nachricht. Der Link trägt ein Geheimnis, das Ihr Gerät nie verlässt.',
  'landing.step3.title': 'Eine Wiedergabe',
  'landing.step3.body':
    'Die erste Sitzung reserviert den Link endgültig. Danach werden die Dateien serverseitig zerstört.',
  'landing.limits.title': 'Was BOOMSHOT leistet',
  'landing.limits.guaranteed': 'Serverseitig garantiert',
  'landing.limits.g1': 'Genau eine Wiedergabesitzung pro Link, atomar reserviert.',
  'landing.limits.g2': 'Fragmente nur mit kurzlebigen Tokens, ohne dauerhafte URL.',
  'landing.limits.g3':
    'Geprüfte Löschung der Quelldatei, der Fragmente und der Vorschaubilder.',

  'auth.signIn.title': 'Anmelden',
  'auth.signIn.subtitle': 'Zugriff auf Ihre Videos und aktiven Links.',
  'auth.signIn.submit': 'Anmelden',
  'auth.signIn.noAccount': 'Noch kein Konto?',
  'auth.signIn.create': 'Konto erstellen',
  'auth.signIn.magicLink': 'Anmeldelink zusenden',
  'auth.signIn.usePassword': 'Passwort verwenden',
  'auth.signIn.forgot': 'Passwort vergessen',
  'auth.signIn.magicSent':
    'Falls ein Konto mit dieser Adresse existiert, wurde soeben ein Anmeldelink verschickt. Er funktioniert nur einmal.',
  'auth.signUp.title': 'Konto erstellen',
  'auth.signUp.subtitle':
    'Zum Senden brauchen Sie ein Konto. Ihre Empfänger brauchen nie eines.',
  'auth.signUp.submit': 'Konto erstellen',
  'auth.signUp.hasAccount': 'Bereits registriert?',
  'auth.signUp.terms':
    'Mir ist bewusst, dass ein im Browser abgespieltes Video immer per Bildschirmaufnahme mitgeschnitten werden kann und dass BOOMSHOT eine einmalige Wiedergabe garantiert, keinen Kopierschutz.',
  'auth.reset.title': 'Passwort vergessen',
  'auth.reset.subtitle': 'Wir senden Ihnen einen Link zum Zurücksetzen.',
  'auth.reset.submit': 'Link senden',
  'auth.reset.sent':
    'Falls ein Konto mit dieser Adresse existiert, wurde soeben eine E-Mail zum Zurücksetzen verschickt. Prüfen Sie auch den Spam-Ordner.',
  'auth.reset.back': 'Zurück zur Anmeldung',
  'auth.callback.title': 'Anmeldung läuft',
  'auth.callback.subtitle': 'Ihr Link wird geprüft…',
  'auth.callback.invalid': 'Das ist kein gültiger Anmeldelink.',
  'auth.callback.requestNew': 'Neuen Link anfordern',
  'auth.google': 'Weiter mit Google',
  'auth.email': 'E-Mail-Adresse',
  'auth.emailPlaceholder': 'sie@beispiel.de',
  'auth.password': 'Passwort',
  'auth.passwordConfirm': 'Passwort bestätigen',
  'auth.passwordHint': 'Mindestens 10 Zeichen, mit Groß- und Kleinbuchstabe und Ziffer.',
  'auth.magicHint': 'Sie erhalten einen einmalig gültigen Link, ganz ohne Passwort.',
  'auth.confirmEmailPrompt': 'Bestätigen Sie Ihre E-Mail-Adresse, um die Anmeldung abzuschließen',

  'authError.invalidCredential': 'E-Mail-Adresse oder Passwort falsch.',
  'authError.emailInUse':
    'Dieses Konto konnte nicht erstellt werden. Melden Sie sich an oder setzen Sie Ihr Passwort zurück.',
  'authError.weakPassword': 'Passwort zu schwach.',
  'authError.tooManyRequests': 'Zu viele Versuche. Versuchen Sie es in einigen Minuten erneut.',
  'authError.network': 'Keine Verbindung. Prüfen Sie Ihr Netzwerk.',
  'authError.popupClosed': 'Das Fenster wurde vor Abschluss der Anmeldung geschlossen.',
  'authError.popupBlocked': 'Der Browser hat das Fenster blockiert.',
  'authError.recentLogin':
    'Aus Sicherheitsgründen müssen Sie sich vor dem Fortfahren erneut anmelden.',
  'authError.invalidActionCode': 'Dieser Anmeldelink ist ungültig oder wurde bereits verwendet.',
  'authError.expiredActionCode': 'Dieser Anmeldelink ist abgelaufen. Fordern Sie einen neuen an.',
  'authError.generic': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',

  'dashboard.title': 'Meine Videos',
  'dashboard.subtitle': 'Jeder Link erlaubt genau eine Wiedergabesitzung.',
  'dashboard.send': 'Video senden',
  'dashboard.metric.activeLinks': 'Aktive Links',
  'dashboard.metric.watched': 'Angesehene Videos',
  'dashboard.metric.storage': 'Temporärer Speicher',
  'dashboard.search': 'Suchen',
  'dashboard.searchPlaceholder': 'Nach Name oder Empfänger suchen',
  'dashboard.filters': 'Filter',
  'dashboard.filterStatus': 'Status',
  'dashboard.filterAll': 'Alle Status',
  'dashboard.sort': 'Sortierung',
  'dashboard.sortNewest': 'Neueste zuerst',
  'dashboard.sortOldest': 'Älteste zuerst',
  'dashboard.sortExpiring': 'Läuft bald ab',
  'dashboard.empty.title': 'Noch keine Videos',
  'dashboard.empty.body':
    'Senden Sie Ihr erstes Video: Es wird umgewandelt, mit einem einmalig gültigen Link geschützt und nach der ersten Wiedergabe gelöscht.',
  'dashboard.noResults.title': 'Keine Treffer',
  'dashboard.noResults.body':
    'Kein Video passt zu dieser Suche. Versuchen Sie einen anderen Begriff oder setzen Sie die Filter zurück.',
  'dashboard.loadError': 'Ihre Videos konnten nicht geladen werden. Prüfen Sie Ihre Verbindung.',
  'dashboard.loadBlocked': 'Ihre Videos konnten nicht geladen werden. Der Dienst ist nicht korrekt konfiguriert - es liegt nicht an Ihnen.',
  'dashboard.expiresIn': 'Läuft ab {when}',
  'dashboard.viewedAt': 'Angesehen {when}',
  'dashboard.createdAt': 'Erstellt {when}',
  'dashboard.forRecipient': 'Für {name}',

  'status.processing': 'In Verarbeitung',
  'status.ready': 'Bereit',
  'status.opened': 'Link geöffnet',
  'status.playing': 'Wird abgespielt',
  'status.watched': 'Angesehen',
  'status.expired': 'Abgelaufen',
  'status.deleted': 'Gelöscht',
  'status.error': 'Fehler',

  'upload.title': 'Video senden',
  'upload.subtitle':
    'Es wird umgewandelt, mit einem einmalig gültigen Link geschützt und nach der ersten Wiedergabe gelöscht.',
  'upload.drop': 'Video hier ablegen',
  'upload.formats': '{formats} - bis {size}',
  'upload.choose': 'Datei auswählen',
  'upload.progress': 'Upload-Fortschritt',
  'upload.inProgress': 'Wird hochgeladen…',
  'upload.converting': 'Wird umgewandelt…',
  'upload.cancelUpload': 'Upload abbrechen',
  'upload.processingNote':
    'Umwandlung in sichere Fragmente. Sie müssen nicht warten: Erstellen Sie den Link jetzt, er funktioniert, sobald dies abgeschlossen ist.',
  'upload.restart': 'Neu beginnen',
  'upload.error.format': 'Format nicht unterstützt. Verwenden Sie MP4, MOV oder WebM.',
  'upload.error.tooLarge': 'Datei zu groß (maximal {size}).',
  'upload.error.notVideo': 'Diese Datei sieht nicht nach einem gültigen Video aus.',
  'upload.error.unreadable': 'Diese Datei konnte nicht als Video gelesen werden.',
  'upload.error.tooLong': 'Video zu lang ({duration}). Maximal {max}.',
  'upload.error.failed': 'Der Upload ist fehlgeschlagen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  'upload.error.transcode':
    'Die Umwandlung dieses Videos ist fehlgeschlagen. Die Datei wurde gelöscht. Versuchen Sie ein anderes Format.',
  'upload.error.tracking': 'Die Verarbeitung wird nicht mehr verfolgt. Laden Sie die Seite neu.',

  'config.expiry': 'Ablauf des Links',
  'config.expiry1h': '1 Stunde',
  'config.expiry24h': '24 Std.',
  'config.expiry3d': '3 Tage',
  'config.expiry7d': '7 Tage',
  'config.expiryCustom': 'Eigenes Datum',
  'config.expiryDate': 'Ablaufdatum und -uhrzeit',
  'config.pin': 'Zugangscode',
  'config.pinHint': '4 bis 8 Ziffern. Getrennt vom Link übermitteln.',
  'config.advanced': 'Erweiterte Optionen',
  'config.internalName': 'Interner Name',
  'config.internalNameHint': 'Nur für Sie sichtbar, nie für den Empfänger.',
  'config.recipient': 'Name des Empfängers',
  'config.recipientHint': 'Wird im Wasserzeichen angezeigt, wenn dieses aktiv ist.',
  'config.watermark': 'Wasserzeichen',
  'config.watermarkNone': 'Keines',
  'config.watermarkSubtle': 'Dezent',
  'config.watermarkReinforced': 'Verstärkt',
  'config.message': 'Nachricht an den Empfänger',
  'config.messagePlaceholder': 'Optional - wird vor der Wiedergabe angezeigt',
  'config.submit': 'Privaten Link erstellen',
  'config.alwaysDeleted':
    'Die Löschung nach dem Ansehen ist immer aktiv und lässt sich nicht abschalten.',
  'config.linkFailed': 'Der Link konnte nicht erzeugt werden.',

  'ready.eyebrow': 'Link erzeugt',
  'ready.title': 'Ihr Link ist bereit. Er funktioniert einmal.',
  'ready.meta': '{name} · {duration} · läuft ab am {date}',
  'ready.stillProcessing':
    'Dieser Link funktioniert bereits, aber das Video wird noch verarbeitet. Wird er sofort geöffnet, muss der Empfänger nur einen Moment warten.',
  'ready.secureLink': 'Sicherer Link',
  'ready.copyFailed': 'Kopieren nicht möglich. Markieren Sie den Link von Hand.',
  'ready.shareTitle': 'Video zur einmaligen Wiedergabe',
  'ready.shareText': 'Dieses Video kann nur ein einziges Mal angesehen werden.',
  'ready.pinWarning':
    'Der Zugangscode wird bewusst nicht mitgeteilt. Übermitteln Sie ihn über einen anderen Kanal (SMS, Anruf), nie in derselben Nachricht wie den Link.',
  'ready.fragmentNote':
    'Der Teil des Links nach dem {hash} ist das Zugangsgeheimnis. Er wird nie an unsere Server gesendet - kopieren Sie den Link vollständig.',
  'ready.protections': 'Aktive Schutzmaßnahmen',
  'ready.protectionSingle': 'Genau eine Wiedergabesitzung',
  'ready.protectionDelete': 'Löschung nach dem Ansehen',
  'ready.protectionPin': 'Zugangscode erforderlich',
  'ready.protectionsNote':
    'Diese Maßnahmen garantieren eine einmalige Wiedergabe. Einen Screenshot oder eine Bildschirmaufnahme können sie nicht verhindern.',
  'ready.qr': 'QR-Code',
  'ready.qrAlt': 'QR-Code des sicheren Links für {name}',
  'ready.sendAnother': 'Weiteres Video senden',
  'ready.backToDashboard': 'Zurück zur Übersicht',
  'ready.leaveWarnTitle': 'Sie haben diesen Link noch nicht kopiert',
  'ready.leaveWarnBody':
      'Er wird nur dieses eine Mal angezeigt und nirgendwo gespeichert. Wenn Sie jetzt gehen, ohne ihn zu kopieren oder zu teilen, kann ihn niemand mehr abrufen - auch Sie nicht. Sie müssten den Link dieses Videos widerrufen und es erneut senden.',
  'ready.leaveAnyway': 'Ohne Kopieren verlassen',
  'ready.copyNow': 'Link kopieren',
  'ready.watermarkNone': 'Kein Wasserzeichen',
  'ready.watermarkSubtle': 'Dezentes Wasserzeichen',
  'ready.watermarkReinforced': 'Verstärktes Wasserzeichen',

  'detail.notFound.title': 'Video nicht gefunden',
  'detail.notFound.body': 'Dieses Video existiert nicht mehr oder gehört Ihnen nicht.',
  'detail.duration': 'Dauer',
  'detail.size': 'Größe',
  'detail.created': 'Erstellt am',
  'detail.recipient': 'Empfänger',
  'detail.expiry': 'Ablauf',
  'detail.viewedOn': 'Angesehen am',
  'detail.deletedOn': 'Gelöscht am',
  'detail.pinRequired': 'Erforderlich',
  'detail.consumedNote':
    'Dieses Video wurde angesehen. Der Link ist endgültig unbrauchbar und die Dateien wurden aus dem Speicher gelöscht.',
  'detail.failedNote':
    'Die Verarbeitung dieses Videos ist fehlgeschlagen. Es wurde kein Link erzeugt und die temporären Dateien wurden gelöscht.',
  'detail.lastError': 'Letzter vom Server gemeldeter Fehler:',
  'detail.copyLink': 'Link kopieren',
  'detail.secretLost':
    'Das Linkgeheimnis wird nie gespeichert: Es erscheint nur bei der Erzeugung. Widerrufen Sie diesen Link und erstellen Sie einen neuen, falls Sie ihn verloren haben.',
  'detail.revoke': 'Link widerrufen',
  'detail.deleteNow': 'Jetzt löschen',
  'detail.reuse': 'Diese Einstellungen erneut verwenden',
  'detail.revokeTitle': 'Diesen Link widerrufen?',
  'detail.revokeBody':
    'Der Link funktioniert sofort nicht mehr. Anschließend wird das Video gelöscht.',
  'detail.revoked': 'Link widerrufen.',
  'detail.deleteTitle': 'Dieses Video löschen?',
  'detail.deleteBody':
    'Quelldatei, Fragmente und Vorschaubilder werden zerstört. Das lässt sich nicht rückgängig machen.',
  'detail.deleteStarted': 'Löschung gestartet.',
  'detail.actionFailed': 'Diese Aktion ist derzeit nicht möglich.',

  'settings.title': 'Konto und Datenschutz',
  'settings.subtitle': 'Was BOOMSHOT aufbewahrt und was es nicht garantieren kann.',
  'settings.identity': 'Identität',
  'settings.anonymous': 'Anonymes Konto',
  'settings.memberSince': 'Mitglied seit {date}',
  'settings.dataKept': 'Aufbewahrte Daten',
  'settings.dataKept1':
    'Nach dem Löschen eines Videos behält BOOMSHOT nur eine minimale Spur: Status, Erstellungsdatum, Ansehdatum, Löschdatum, Dauer und den von Ihnen gewählten Namen.',
  'settings.dataKept2':
    'Es wird keine vollständige IP-Adresse gespeichert. Es bleibt kein Vorschaubild, kein Videofragment und keine Quelldatei zurück.',
  'settings.limitsTitle': 'Tatsächliche Grenzen des Schutzes',
  'settings.limits1':
    'Ein im Browser abgespieltes Video lässt sich immer kopieren: Screenshot, Bildschirmaufnahme, eine externe Kamera vor dem Bildschirm oder eine technisch versierte Extraktion.',
  'settings.limits2':
    'BOOMSHOT garantiert, dass ein Link genau eine Wiedergabesitzung öffnet und die Dateien danach serverseitig zerstört werden. Es garantiert nicht, dass das Bild nicht kopiert werden kann.',
  'settings.deleteAccount': 'Konto löschen',
  'settings.deleteAccountBody':
    'Alle Ihre Videos, Links und Dateien werden zerstört. Das lässt sich nicht rückgängig machen.',
  'settings.deleteConfirmLabel': 'Geben Sie LÖSCHEN ein, um zu bestätigen',
  'settings.deleteConfirmWord': 'LÖSCHEN',
  'settings.deleteSubmit': 'Mein Konto endgültig löschen',
  'settings.deleted': 'Konto gelöscht.',
  'settings.signOutFailed': 'Abmelden ist derzeit nicht möglich.',

  'viewer.checking': 'Link wird geprüft…',
  'viewer.preparing': 'Fast fertig - das Video des Absenders wird noch vorbereitet.',
  'viewer.eyebrow': 'Einmalige Wiedergabe',
  'viewer.title': 'Dieses Video kann nur ein einziges Mal angesehen werden.',
  'viewer.subtitle':
    'Starten Sie es, wenn Sie bereit sind, und achten Sie auf eine stabile Verbindung.',
  'viewer.sender': 'Absender',
  'viewer.message': 'Nachricht',
  'viewer.duration': 'Dauer',
  'viewer.deadline': 'Verfügbar bis',
  'viewer.warning':
    'Sobald Sie die Wiedergabe starten, wird der Link endgültig unbrauchbar. Es gibt keine Wiederholung, kein Zurückspulen und keine zweite Sitzung - auch nicht, wenn Sie die Seite versehentlich schließen.',
  'viewer.start': 'Einmalige Wiedergabe starten',
  'viewer.startWithPin': 'Bestätigen und einmalige Wiedergabe starten',
  'viewer.pinHint': 'Diesen Code hat Ihnen der Absender separat mitgeteilt.',
  'viewer.pinWrong': 'Falscher Code.',
  'viewer.pinWrongRetry': 'Falscher Code. Versuchen Sie es in {seconds} s erneut.',
  'viewer.retryIn': 'Neuer Versuch in {seconds} s',
  'viewer.noPreload': 'Vor Ihrer Bestätigung wird kein Videofragment geladen.',
  'viewer.checkFailed': 'Dieser Link konnte derzeit nicht geprüft werden.',
  'viewer.claimFailed': 'Die Wiedergabesitzung konnte nicht geöffnet werden.',
  'viewer.unavailable.title': 'Dieser Link ist nicht mehr gültig',
  'viewer.unavailable.body':
    'Er wurde vielleicht bereits verwendet oder widerrufen, oder es gab ihn nie. Aus Datenschutzgründen können wir nicht mehr sagen. Bitten Sie den Absender um einen neuen Link.',
  'viewer.expired.title': 'Dieser Link ist abgelaufen',
  'viewer.expired.body':
    'Die vom Absender gesetzte Frist ist verstrichen und das Video wurde gelöscht. Bitten Sie um einen neuen Link, falls Sie es noch ansehen müssen.',
  'viewer.used.title': 'Dieses Video wurde bereits geöffnet',
  'viewer.used.body':
    'Für diesen Link wurde bereits eine Wiedergabesitzung gestartet. Eine weitere ist nicht möglich, und das Video wurde gelöscht.',
  'viewer.stillProcessing.title': 'Dieses Video wird noch vorbereitet',
  'viewer.stillProcessing.body':
    'Das dauert länger als üblich. Der Link selbst ist in Ordnung - öffnen Sie ihn in ein paar Minuten erneut, dann sollte das Video bereit sein.',
  'viewer.consumed.title': 'Video angesehen und gelöscht',
  'viewer.consumed.body':
    'Die Wiedergabe ist beendet. Der Link ist nun unbrauchbar und die Dateien wurden auf unseren Servern zerstört.',
  'viewer.error.title': 'Wiedergabe nicht möglich',

  'player.preloading': 'Sicheres Vorladen…',
  'player.tapToPlay': 'Zum Abspielen tippen',
  'player.tapToPlayHint': 'Die einmalige Wiedergabe beginnt, sobald Sie auf Play tippen.',
  'player.stalled': 'Instabile Verbindung - die Wiedergabe wird automatisch fortgesetzt.',
  'player.play': 'Abspielen',
  'player.pause': 'Pausieren',
  'player.mute': 'Stummschalten',
  'player.unmute': 'Ton einschalten',
  'player.volume': 'Lautstärke',
  'player.fullscreen': 'Vollbild',
  'player.exitFullscreen': 'Vollbild beenden',
  'player.progress': 'Wiedergabefortschritt',
  'player.unsupported': 'Ihr Browser kann dieses Video nicht abspielen.',
  'player.fatal': 'Die Wiedergabe wurde unterbrochen und kann nicht fortgesetzt werden.',

  'notFound.title': 'Seite nicht gefunden',
  'notFound.body':
    'Zu dieser Adresse gibt es nichts. Falls Sie einen Videolink erhalten haben, prüfen Sie, ob er vollständig kopiert wurde - der Teil nach dem {hash} ist unverzichtbar.',
  'notFound.home': 'Zurück zur Startseite',

  'apiError.network': 'Keine Verbindung. Prüfen Sie Ihr Netzwerk.',
  'apiError.unauthenticated': 'Sitzung abgelaufen. Bitte melden Sie sich erneut an.',
  'apiError.forbidden': 'Zugriff verweigert.',
  'apiError.notFound': 'Nicht gefunden.',
  'apiError.conflict': 'Diese Aktion wurde bereits ausgeführt.',
  'apiError.rateLimited': 'Zu viele Versuche. Versuchen Sie es gleich erneut.',
  'apiError.badResponse': 'Unerwartete Antwort vom Server.',
  'apiError.internal': 'Auf unserer Seite ist etwas schiefgelaufen.',
  'apiError.badRequest': 'Ungültige Anfrage.',

  'validation.required': 'Erforderlich',
  'validation.invalidFormat': 'Ungültiges Format',
  'validation.tooLong': 'Zu lang',
  'validation.unsafeCharacters': 'Nicht erlaubte Zeichen',
  'validation.email': 'Ungültige E-Mail-Adresse',
  'validation.passwordMin': 'Mindestens 10 Zeichen',
  'validation.passwordComplexity':
    'Muss einen Klein-, einen Großbuchstaben und eine Ziffer enthalten',
  'validation.passwordMismatch': 'Die Passwörter stimmen nicht überein',
  'validation.termsRequired': 'Sie müssen die Bedingungen akzeptieren',
  'validation.pinDigits': 'Der Code muss numerisch sein',
  'validation.pinMin': 'Mindestens {min} Ziffern',
  'validation.pinMax': 'Höchstens {max} Ziffern',
  'validation.messageTooLong': 'Nachricht zu lang (maximal 500 Zeichen)',
  'validation.dateRequired': 'Wählen Sie ein Datum',
  'validation.dateTooSoon': 'Das Datum muss mindestens 5 Minuten in der Zukunft liegen',
  'validation.dateTooFar': 'Das Datum darf höchstens 30 Tage entfernt sein',
  'validation.confirmDelete': 'Geben Sie LÖSCHEN ein, um zu bestätigen',

  'state.errorTitle': 'Etwas ist schiefgelaufen',
};
